// removed by extract-text-webpack-plugin
module.exports = {"list":"c-ProductsList__list","loadLessButton":"c-ProductsList__loadLessButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/ProductsList/ProductsList.scss
// module id = 900
// module chunks = 0